import React from "react";

import { Outlet } from "react-router-dom";

import image from "~/images/influx_logo_white.png";

export default function AdminPublicLayout() {
  return (
    <div className="w-screen h-screen bg-slate-900">
      <img src={image} alt="" className="max-w-[300px] w-full mx-auto pt-5" />
      <Outlet />
    </div>
  );
}
